import { FC } from "react";
//import { AnalystCard } from "../../../shared/ui/analyst-card";
import { AnalystTrends } from "../analyst-trends-section";
import { IAnalyst, IAnalystTrendsDto } from "../../../../../../../services/tipRanks/types";
import styles from "./BestAnalysts.module.scss";
import { useTranslation } from "next-i18next";

// enum Tabs {
//     Accurate = "Accurate",
//     Profitable = "Profitable",
// }

interface BestAnalystsProps {
    analysts: IAnalyst[];
    trends: IAnalystTrendsDto[];
    ticker: string;
    averageTarget: number;
}

// TODO: define real time period for analyst card
// const getAnalystTimePeriod = (index: number) => {
//     switch (index) {
//         case 0:
//             return "1 Months";
//         case 1:
//             return "3 Months";
//         case 2:
//             return "1 Year";
//         default:
//             return "2 Years";
//     }
// };

export const BestAnalysts: FC<BestAnalystsProps> = ({ trends, ticker, averageTarget }) => {
    // const [activeTab, setActiveTab] = useState<Tabs>(Tabs.Accurate);
    const { t } = useTranslation("common");

    const buyDescSummary = trends[trends.length - 1]?.buy + trends[trends.length - 1]?.strongBuy;
    const holdDescSummary = trends[trends.length - 1]?.hold;
    const sellDescSummary = trends[trends.length - 1]?.sell + trends[trends.length - 1]?.strongSell;

    // let bestAnalysts;

    // if (activeTab === Tabs.Accurate) {
    //     bestAnalysts = analysts.toSorted((a, b) => b.successRate - a.successRate).slice(0, 4);
    // } else {
    //     bestAnalysts = analysts.toSorted((a, b) => b.stockAvgReturn - a.stockAvgReturn).slice(0, 4);
    // }

    return (
        <div className={styles.container}>
            {/*  <div className={styles.tabs}>
                <div
                    onClick={() => setActiveTab(Tabs.Accurate)}
                    className={clsx(styles.tab, {
                        [styles.activeTab]: activeTab === Tabs.Accurate,
                    })}>
                    Most Accurate Analysis
                </div>
                <div
                    onClick={() => setActiveTab(Tabs.Profitable)}
                    className={clsx(styles.tab, {
                        [styles.activeTab]: activeTab === Tabs.Profitable,
                    })}>
                    Most Profitable Analysts
                </div>
            </div>
            <h2 className={styles.subtitle}>
                Which Analyst Should I Follow If I Want to Buy {ticker} and Sell After
            </h2>
            <div className={styles.analystsCards}>
                {bestAnalysts.map((analyst, index) => (
                    <AnalystCard
                        analyst={analyst}
                        key={index}
                        averageReturn={analyst.stockAvgReturn}
                        timePeriod={getAnalystTimePeriod(index)}
                    />
                ))}
            </div> */}
            <div className={styles.analystTrendsChart}>
                <h2 className={styles.title}>
                    {t("analytics.analystForecasts.bestAnalysts.title", { ticker })}
                </h2>
                <AnalystTrends data={trends} />
                <div className={styles.description}>
                    {t("analytics.analystForecasts.bestAnalysts.description", {
                        ticker,
                        buyCount: buyDescSummary,
                        holdCount: holdDescSummary,
                        sellCount: sellDescSummary,
                        averageTarget,
                    })}
                </div>
            </div>
        </div>
    );
};
